import { defineMessages } from 'react-intl';

export default defineMessages({
  headTitle: {
    id: 'welcome.head.title',
    defaultMessage: 'Sign up',
  },
  subheadingResumeSignup: {
    id: 'welcome.signup.subheading.title',
    defaultMessage: 'Finish setting up your account',
    description:
      'Shown before the login form. e.g. "Sign up first then we will show you the content you requested"',
  },
  subheadingMigration: {
    id: 'welcome.migration.subheading.title',
    defaultMessage: 'Complete your migration',
  },
  emailVerifiedTitle: {
    id: 'resume.signup.head.title',
    defaultMessage: 'Email address verified',
  },
  contextualHeadTitle: {
    id: 'signup.contextual.head.title',
    defaultMessage: 'Sign up to continue to',
    description: `Precedes a page title or issue number. For example, "Sign up to continue to Sarah's Blogpost"`,
  },
  socialAuthOr: {
    id: 'social.auth.or',
    defaultMessage: 'or',
  },
  socialAuthOrContinueWith: {
    id: 'social.auth.or-continue-with',
    defaultMessage: 'Or continue with:',
  },
  headerTitle: {
    id: 'signup.header.title',
    defaultMessage: 'Sign up to continue',
    description:
      'Shown before the login form. e.g. "Sign up first then we will show you the content you requested"',
  },
  startCollaboratingHeaderTitle: {
    id: 'welcome.header.start.collaborating.title',
    defaultMessage: 'Sign up to start collaborating',
    description:
      'Shown before the signup form. e.g. "Sign up first then we will show you the content you requested"',
  },
  headerWACExperiment: {
    id: 'welcome.signup.wac.header.title',
    defaultMessage: 'Add your account details',
    description: 'Heading for the signup form',
  },
  subheadingWACExperiment: {
    id: 'welcome.signup.wac.subheading.title',
    defaultMessage:
      'This account can be used for {productName} and any other Atlassian product you add in the future.',
    description:
      'Subheading for the signup form. productName is the name of the product the user is signing up for, e.g. "This account can be used for Jira and ..."',
  },
});
